<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center :append-to-body="true"
             :close-on-click-modal="false"
  >
    <div class="search-content" v-if="false">
      <el-col :span="24" class="toobar">
        <el-input style="width:200px;"
                  placeholder="请输入内容"
                  prefix-icon="el-icon-search"
                  v-model="searchdata">
        </el-input>
        <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="initData(seedcodes)">搜索</el-button>
      </el-col>
    </div>

    <el-table
      :data="tableData"
      :height="tableHeight()"
      size="mini"
      stripe
      border
      style="width: 100%;"
    >
      <el-table-column type="index" width="60" label="序号" align="center">
      </el-table-column>
      <el-table-column
        prop="customerserial"
        label="编码"
        align="center"
        header-align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="deptname"
        label="名称"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <!--<el-table-column prop="unitgroup" label="分类" align="left" header-align="center" width="150">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
      <!--label="区域"-->
      <!--align="left"-->
      <!--header-align="center"-->
      <!--&gt;-->
      <!--<template slot-scope="scope">-->
      <!--{{scope.row.province}}{{scope.row.city}}{{scope.row.county}}-->
      <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column label="操作" align="center" width="90">
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="handleSelect(scope.$index, scope.row)">选择
          </el-button>

        </template>
      </el-table-column>
    </el-table>

    <!--<div class="foot" :style="{textAlign:'center' }">-->
      <!--<Pagination ref="pagination1" :pagination="pagination"></Pagination>-->
    <!--</div>-->
    <!--<div slot="footer" class="dialog-footer">-->
    <!--<el-button @click="dialogFormVisible = false">取 消</el-button>-->
    <!--</div>-->
  </el-dialog>


</template>

<script>
  //  import ExternaldeptEdit from './externaldeptEdit';
  import {getListData, deleteData, getControlData, suppliers} from '@/api/set/externaldept';

  export default {
    name: 'ExternaldeptChaiDanSel',
    data() {
      return {
        activeIndex: '1',
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        searchdata: "",
        controlData: [],
        loading: true,
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: [],
        seedcodes: [],

      }
    },
    props: {
      unitgroup: {
        default: 1
      },
      title: {
        default: "客户信息"
      }
    },
    methods: {
      initData(seedcodes) {
        this.seedcodes = seedcodes
        suppliers({
          seedcodes: JSON.stringify(this.seedcodes),
          search: this.searchdata
        }).then(response => {
          this.tableData = response.data.obj

        })
      },
      handleSelect(index, row) {
        this.$emit("select", row.customerserial, row.deptname, row)
        this.dialogFormVisible = false
      },
      add() {
        this.$refs.DataContactEdit.initForm()
        this.OpenDialog()
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show()
      },
      show() {
        this.dialogFormVisible = true
      }
    },
    mounted() {
      getControlData().then(response => {
        this.controlData = response.data.obj
      })
      // this.bindGrid();
    },
    components: {
//      ExternaldeptEdit,
    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/ExternaldeptChaiDanSel.vue